import React from 'react'
import { LandingPageDto } from 'api/ClientArea/LandingPageDto'
import { PreviewPromoMaterialLandingPage } from 'api/ClientArea/PreviewPromoMaterials'
import { PromoMaterialsOptionsDto } from 'api/ClientArea/PromoMaterialsOptionsDto'
import { FormSubmitValues } from 'utils/formValidation'

import {
  CreatePromoMaterialValues,
  PromoMaterialForm,
  UpdatePromoMaterialValues,
} from './PromoMaterialForm'

interface OuterProps {
  data: LandingPageDto
  promoMaterialsOptions: PromoMaterialsOptionsDto
  promoMaterialsPreview: PreviewPromoMaterialLandingPage[]
  onSubmit(
    values: FormSubmitValues<UpdatePromoMaterialValues | CreatePromoMaterialValues>
  ): Promise<void>
  onValidate?(
    values: FormSubmitValues<CreatePromoMaterialValues[] | UpdatePromoMaterialValues[]>
  ): Promise<PreviewPromoMaterialLandingPage[] | undefined>
}

export const PromoMaterialSaveForm: React.FC<OuterProps> = (props) => {
  const { promoMaterialsPreview } = props
  const [promoMaterialPreview] = promoMaterialsPreview
  return <PromoMaterialForm {...props} promoMaterialPreview={promoMaterialPreview} isNew />
}
